import type { IconData } from '@stacksjs/iconify-core'

export const se4x3: IconData = {
  "body": "<path fill=\"#005293\" d=\"M0 0h640v480H0z\"/><path fill=\"#fecb00\" d=\"M176 0v192H0v96h176v192h96V288h368v-96H272V0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default se4x3
